import PropTypes from 'prop-types';
import React from 'react';

const NPOVideoPlayer = ({ embedId, title, ...props }) => (
  <iframe
    src={`https://start-player.npo.nl/embed/${embedId}`}
    title={title}
    width="100%"
    height="100%"
    frameBorder="0"
    scrolling="no"
    allowFullScreen
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
    allow="encrypted-media"
    {...props}
  />
);

NPOVideoPlayer.propTypes = {
  title: PropTypes.string.isRequired,
  embedId: PropTypes.string.isRequired,
};

export default NPOVideoPlayer;
